<template>
    <a v-if="author.profile_updated && author.phone_verified" :href="$root.url('orn_web_user_view', { username : author.username  })" class="text-danger">
        {{ author.display_name }}
    </a>
    <span v-else>{{ author.display_name }}</span>
</template>

<script>
    export default {
        name: 'PostAuthor',
        props: ['author']
    }
</script>

<style scoped>
</style>